(function () {
  var REVEALED = 'is-revealed';
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal(el) {
    el.classList.add(REVEALED);
  }

  function revealAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-reveal]'), reveal);
  }

  function init() {
    var targets = document.querySelectorAll('[data-reveal]:not(.' + REVEALED + ')');

    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      revealAll();
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            reveal(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -6% 0px' }
    );

    Array.prototype.forEach.call(targets, function (el) {
      observer.observe(el);
    });
  }

  // Safety net: anything already on screen must never stay hidden, whatever the
  // observer decided. Content below the fold keeps its scroll-triggered reveal.
  function revealWhatIsOnScreen() {
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-reveal]:not(.' + REVEALED + ')'),
      function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) {
          reveal(el);
        }
      }
    );
  }

  function start() {
    try {
      init();
      window.setTimeout(revealWhatIsOnScreen, 2500);
    } catch (error) {
      // An entrance animation is never worth a blank section.
      revealAll();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', start);
})();
